import { useFragment } from "react-relay";
import { FormattedMessage } from "react-intl";
import { Fragment } from ".";
import { PublishModal } from "./modal";
import { Button, ButtonProps } from "@/kit/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from "@/kit/ui/tooltip";
import { DatasetVersionPublishButtonFragment$key } from "./__generated__/DatasetVersionPublishButtonFragment.graphql";

export interface DatasetVersionPublishButtonProps extends ButtonProps {
  datasetVersion: DatasetVersionPublishButtonFragment$key;
}

export default function DatasetVersionPublishButton({
  datasetVersion: datasetVersionFragment,
  children,
  ...props
}: DatasetVersionPublishButtonProps) {
  const datasetVersion = useFragment(Fragment, datasetVersionFragment);

  if (!datasetVersion.viewerCanPublishDatasetVersion) {
    return null;
  }

  if (!datasetVersion.publishable) {
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button className="w-full" disabled>
            <FormattedMessage defaultMessage="Publish version" />
          </Button>
        </TooltipTrigger>

        <TooltipPortal>
          <TooltipContent>
            <FormattedMessage
              defaultMessage="Upload a file to {version} before publishing"
              values={{ version: datasetVersion.version }}
            />
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    );
  }

  return (
    <PublishModal datasetVersionId={datasetVersion.id} asChild>
      <Button {...props}>{children}</Button>
    </PublishModal>
  );
}
